import type { Novidade } from './tipos';

/** Fase 2 (W9): e-mail do atendimento, filas, mídia e janela de 24 h em Conversas. */
export const novidadeConversasEmail: Novidade = {
  id: '2026-10-05-conversas-email',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'conversas',
  permissao: 'conversas.ver',
  textos: {
    pt: {
      titulo: 'E-mail do atendimento e filas em Conversas',
      resumo: 'O e-mail do atendimento vira conversa, as filas separam a equipe e fotos e documentos ficam na conversa.',
      passos: [
        'Na aba E-mail, cada e-mail da caixa monitorada vira uma conversa. As imagens externas ficam bloqueadas até você clicar em Mostrar imagens.',
        'Responda pela própria conversa: a resposta vai na mesma thread, com a sua assinatura e os anexos.',
        'Na aba Filas, crie as filas da equipe com distribuição manual ou em rodízio. Cada atendente vê a fila dele.',
        'Fotos e documentos recebidos pelo WhatsApp ficam na conversa. Use o clipe para enviar um arquivo.',
      ],
    },
    en: {
      titulo: 'Support email and queues in Conversations',
      resumo: 'Support email becomes a conversation, queues split the team and photos and documents stay in the conversation.',
      passos: [
        'In the Email tab, each email in the monitored mailbox becomes a conversation. External images stay blocked until you click Show images.',
        'Reply from the conversation: the reply goes in the same thread, with your signature and the attachments.',
        'In the Queues tab, create your team queues with manual or round robin distribution. Each agent sees their own queue.',
        'Photos and documents received on WhatsApp stay in the conversation. Use the paperclip to send a file.',
      ],
    },
    es: {
      titulo: 'Correo de atención y colas en Conversaciones',
      resumo: 'El correo de atención se vuelve conversación, las colas separan al equipo y fotos y documentos quedan en ella.',
      passos: [
        'En la pestaña Correo, cada correo del buzón monitoreado se vuelve una conversación. Las imágenes externas quedan bloqueadas hasta que hagas clic en Mostrar imágenes.',
        'Responde desde la conversación: la respuesta va en el mismo hilo, con tu firma y los adjuntos.',
        'En la pestaña Colas, crea las colas del equipo con distribución manual o rotación. Cada agente ve su cola.',
        'Las fotos y documentos recibidos por WhatsApp quedan en la conversación. Usa el clip para enviar un archivo.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-conversas-email/email.webp', null, '/novidades/2026-10-05-conversas-email/filas.webp', null],
  treinamento: { curso: 'novidades' },
  rota: '/comercial/conversas/email',
};
